import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Enrollments } from './pages/Enrollments';
import { Profile } from './pages/Profile';
import { Fields } from './pages/Fields';
import { Settings } from './pages/Settings';
import { Login } from './pages/Login';
import { ToastProvider } from './components/ToastProvider';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <ToastProvider />
      <Routes>
        <Route path="/" element={<Navigate to="/matriculas" replace />} />
        <Route path="/matriculas" element={<Enrollments />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/campos" element={<Fields />} />
        <Route path="/configuracoes" element={<Settings />} />
        <Route path="/login" element={<Login onLoginSuccess={() => {}} />} />
      </Routes>
    </Router>
  </StrictMode>
);